import React from "react";

import { Button, Link, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Service from "../../../util/Service";
import HtmlContentPage from "./HtmlContentPage";
import EditComp from "../../util/EditComp";
import EditarPaginaHtml from "../editar/EditarPaginaHtml";
import HtmlContent from "../../util/HtmlContent";

export default function LayoutFooter(props) {
    const { edit, setEdit } = props;
    const navigate = useNavigate();
    const [adm, setAdm] = React.useState(edit)
    const [pagina, setPagina] = React.useState();
    const [openEditar, setOpenEditar] = React.useState(false);

    React.useEffect(() => {
        Service.GET('/api/paginaHtml/buscaPorNome/Footer').then(r => {
            if (r && r.length > 0) {
                setPagina(r[0]);
            }
        });
    }, [])

    const handleAdm = () => {
        const accessToken = localStorage.getItem("accessToken")
        console.log(accessToken);
        if (!edit) {
            Service.GET("/api/user/checkAccessToken/" + accessToken).then(r => {
                if (!r.valid) {
                    navigate("/login");
                    return;
                }
                setEdit(true);
                setAdm(true);
            })
        } else {
            setEdit(false);
        }
    }
    function handleEditarPagina() {
        setOpenEditar(true);
    }
    function handelDoAction(retorno) {
        console.log(retorno);
        setPagina(retorno);
    }
    return (
        <div className="main-footer">
            {/* <HtmlContentPage htmlString={pagina ? pagina.pagina : ''} edit={edit} /> */}
            <HtmlContent htmlString={pagina ? pagina.pagina:''} edit={false} />
        </div>
    );
}
